'use client';

import { VpIcon } from '@vtmn-play/react/headless';
import { useTranslations } from 'next-intl';
import { MainColumn } from '@/app/components/MainColumn';
import { Link } from '@/i18n/routing';
import { journeyColumnTemplate } from '~/components/Journey/config';
import appConst from '~/const/appConst';

export const ResultsNavigation = ({ id }: { id: number }) => {
  const t = useTranslations('SURVEY');
  return (
    <MainColumn column={journeyColumnTemplate}>
      <div className="form-actions">
        <Link
          data-cy="backToProjectButton"
          className="vp-button vp-button--secondary button-wrapper-link"
          href={`/${appConst.entityRoutes.interaction}/${id}`}
          prefetch={false}
        >
          <span className="vp-button__label" data-part="label">
            <div data-part="start-slot">
              <VpIcon name="chevron-left" />
            </div>
            {t('GO_BACK_PROJECT')}
          </span>
        </Link>
        <Link
          className="vp-button button-wrapper-link"
          href="/"
          prefetch={false}
        >
          <span className="vp-button__label" data-part="label">
            {t('DISCOVER_PROJECTS')}
          </span>
        </Link>
      </div>
    </MainColumn>
  );
};
